// src/components/Modals/LogoutModal.js
// import React from "react";
// import { Modal, Box, Typography, Button } from "@mui/material"; // Using MUI as an example, adjust if you use a different UI library

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 400,
//   bgcolor: "background.paper",
//   border: "1px solid #ccc",
//   borderRadius: "8px",
//   boxShadow: 24,
//   p: 4,
//   display: "flex",
//   flexDirection: "column",
//   gap: 2,
// };

// function LogoutModal({ open, onClose, onConfirm }) {
//   if (!open) return null;

//   return (
//     <Modal
//       open={open}
//       onClose={onClose} // Allow closing by clicking outside or pressing Esc
//       aria-labelledby="logout-modal-title"
//       aria-describedby="logout-modal-description"
//     >
//       <Box sx={style}>
//         <Typography id="logout-modal-title" variant="h6" component="h2">
//           Confirm Logout
//         </Typography>
//         <Typography id="logout-modal-description" sx={{ mt: 1 }}>
//           Are you sure you want to log out?
//         </Typography>
//         <Box
//           sx={{ mt: 2, display: "flex", justifyContent: "flex-end", gap: 1 }}
//         >
//           <Button variant="outlined" onClick={onClose}>
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             color="error"
//             onClick={onConfirm}
//             autoFocus
//           >
//             Log Out
//           </Button>
//         </Box>
//       </Box>
//     </Modal>
//   );
// }

// export default LogoutModal;

// LogoutModal.js
import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "1px solid #ccc",
  borderRadius: "8px",
  boxShadow: 24,
  p: 4,
  display: "flex",
  flexDirection: "column",
  gap: 2,
  textAlign: "center", // Center text for better layout
};

// Enum for status
const MODAL_STATUS = {
  CONFIRMING: "confirming",
  LOADING: "loading",
  ERROR: "error",
};

function LogoutModal({ open, onClose, onConfirmLogoutAttempt }) {
  const [status, setStatus] = useState(MODAL_STATUS.CONFIRMING);
  const [errorMessage, setErrorMessage] = useState("");

  // Reset state when modal is closed or re-opened
  React.useEffect(() => {
    if (open) {
      setStatus(MODAL_STATUS.CONFIRMING);
      setErrorMessage("");
    }
  }, [open]);

  if (!open) return null;

  const handleConfirm = async () => {
    setStatus(MODAL_STATUS.LOADING);
    try {
      await onConfirmLogoutAttempt();
      // If onConfirmLogoutAttempt resolves, it means success.
      // The parent component will handle navigation and closing the modal.
      // We can call onClose here if parent isn't already handling it post-success.
      // For this example, let's assume parent will close on success.
      // If not, uncomment: onClose();
    } catch (error) {
      console.error("LogoutModal: Logout attempt failed:", error);
      setStatus(MODAL_STATUS.ERROR);
      setErrorMessage(
        error.message ||
          "Cannot log out at the moment due to a technical issue. Please try again later."
      );
    }
  };

  const handleRetry = () => {
    setStatus(MODAL_STATUS.CONFIRMING); // Go back to confirmation or directly to loading
    handleConfirm(); // Or just setStatus(MODAL_STATUS.LOADING) and call handleConfirm
  };

  const renderContent = () => {
    switch (status) {
      case MODAL_STATUS.LOADING:
        return (
          <>
            <Typography variant="h6" component="h2">
              Logging Out
            </Typography>
            <CircularProgress sx={{ alignSelf: "center", my: 2 }} />
            <Typography>Please wait...</Typography>
          </>
        );
      case MODAL_STATUS.ERROR:
        return (
          <>
            <Typography
              id="logout-modal-title"
              variant="h6"
              component="h2"
              color="error"
            >
              Logout Failed
            </Typography>
            <Typography id="logout-modal-description" sx={{ mt: 1 }}>
              {errorMessage}
            </Typography>
            <Box
              sx={{ mt: 2, display: "flex", justifyContent: "center", gap: 1 }}
            >
              <Button variant="outlined" onClick={onClose}>
                Close
              </Button>
              <Button variant="contained" onClick={handleRetry}>
                Retry
              </Button>
            </Box>
          </>
        );
      case MODAL_STATUS.CONFIRMING:
      default:
        return (
          <>
            <Typography id="logout-modal-title" variant="h6" component="h2">
              Confirm Logout
            </Typography>
            <Typography id="logout-modal-description" sx={{ mt: 1 }}>
              Are you sure you want to log out?
            </Typography>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "flex-end",
                gap: 1,
              }}
            >
              <Button variant="outlined" onClick={onClose}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={handleConfirm}
                autoFocus
              >
                Log Out
              </Button>
            </Box>
          </>
        );
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        // Only allow close if not loading. If loading, user must wait.
        // Or, allow closing and cancel the API request (more complex).
        if (status !== MODAL_STATUS.LOADING) {
          onClose();
        }
      }}
      aria-labelledby="logout-modal-title"
      aria-describedby="logout-modal-description"
    >
      <Box sx={style}>{renderContent()}</Box>
    </Modal>
  );
}

export default LogoutModal;
